var app = angular.module('leonardo');

let UtilityService = function () {
  let service = {};
  service.randomFloat = function () {
    const int = window.crypto.getRandomValues(new Uint32Array(1))[0]
    return int / 2 ** 32
  }
  return service;
};

app.factory('UtilityService', [UtilityService]);